import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../images/logo.png';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div className="layout">
      <header className="header">
        <div className="header-content">
          <div className="header-left">
            <img 
              src="/logo.png" 
              alt="Logo" 
              className="logo"
              style={{ cursor: 'pointer' }}
              onClick={() => navigate('/dashboard')}
            />
            <h1>Lastik Saklama Takip</h1>
          </div>
          <div className="header-right">
            {isAdmin && (
              <button 
                className="btn btn-secondary me-2"
                onClick={() => navigate('/admin')}
              >
                Admin Panel
              </button>
            )}
            <button 
              className="btn btn-danger"
              onClick={handleLogout}
            >
              Çıkış Yap
            </button>
          </div>
        </div>
      </header>
      <main className="main-content">
        {children}
      </main>
    </div>
  );
};

export default Layout; 